module.exports = __webpack_public_path__ + "media/06 God rest ye merry gentlemen.4a279b81.mp3";